import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import { backend } from '../axios/backend';
import { Product } from '../types/product';

export type SharedWishes = {
  wishes: Product[];
  sharedBy: { firstname: string; lastname: string; id: string };
  isInSharedWithMe: boolean;
};

export const useSharedWishes = (
  sharedId: string,
  userId?: string,
  options?: UseQueryOptions<unknown, AxiosError, SharedWishes, string[]>,
) =>
  useQuery(
    ['shared-wishes', sharedId],
    async () => {
      const response = await backend.get<SharedWishes>(`wish/shared/${sharedId}`, {
        params: { userId: userId || undefined },
      });
      return response.data;
    },
    options,
  );
